
import { Component, Prop } from "vue-property-decorator";
import VueTreeselect from "@riophae/vue-treeselect";
import AreaTreeBase from "@/components/form/AreaTreeBase";
import { AreaNode } from "@/types/groups/AreaNode";
import { DeviceNode } from "@/types/devices/DeviceNode";

/**
 * Area Tree Picker component which provides the user with a way to select a group (or device) from the tree.
 * Expands to fit a parent container (display: flex is required on the parent).
 *
 * @see https://dev.azure.com/sureviewcc/CC/_wiki/wikis/ImmixCC.wiki/922/Area-Tree-Picker
 */
@Component({
	components: {
		"vue-treeselect": VueTreeselect
	}
})
export default class AreaTreePicker extends AreaTreeBase {
	@Prop({ default: false }) public allowDoubleClick: boolean;
	@Prop({ default: true }) public showSelectedText: boolean;
	@Prop({ default: false }) public clearOnSelect: boolean;

	private clickTimer: NodeJS.Timeout = null;
	private clicks: number = 0;

	/**
	 * Handler for when the user selects a node. If multiple is set to false, and allowDoubleClick is enabled,
	 * a timeout will be used to raise a double click event.
	 */
	private onNodeSelected(node: AreaNode | DeviceNode) {
		if (this.isSearching && this.clearOnSelect) {
			// Manually reset the search query, if we're set to clear on select. We do this ourselves because
			// the treeselect will ignore clearOnSelect if async search is set to true.
			this.$refs.treeSelect.resetSearchQuery();
			this.isSearching = false;
		}

		if (this.allowDoubleClick && !this.multiple) {
			this.clicks++;

			if (this.clicks == 1) {
				this.clickTimer = setTimeout(() => {
					this.onNodeSelectedBase(node);
					this.clicks = 0;
				}, 500);
			} else {
				if (this.clickTimer) {
					clearTimeout(this.clickTimer);
					this.clickTimer = null;
				}

				this.clicks = 0;
				this.onNodeDoubleClicked(node);
			}
		} else {
			this.onNodeSelectedBase(node);
		}
	}

	private onNodeDoubleClicked(node: AreaNode | DeviceNode) {
		this.$emit("double-click", this.reduce(node));
	}
}
